(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('documentField', DocumentField)

    /** @ngInject */
    function DocumentField($rootScope, $q, HelperService, PersonService, UnitService, CompanyRegistryService, PATHS) {
        function DocumentFieldController() {
            const vm = this;

            vm.addDocument = () => {
                vm.amountOfDocuments++;
            }

            vm.removeDocument = index => {
                vm.documents.splice(index, 1);

                vm.amountOfDocuments--;
            }

            vm.getNumber = num => {
                let retArray = [];

                for (let i = 0; i < num; i++)
                    retArray.push(i);

                return retArray;
            }

            vm.isTypeDisabled = (type, indexOwner) => {
                return type.disabled && type.indexOwner != indexOwner;
            }

            vm.onChangeType = (selectedType, indexOwner) => {
                if (!selectedType || isNaN(indexOwner)) return;

                vm.documentTypes.forEach(type => {
                    let isTypeSelected = vm.documents.find(document => {
                        if (type.Id == document.DocumentTypeId)
                            return document;
                    })

                    if (isTypeSelected && !type.disabled) {
                        type.disabled = true;
                        type.indexOwner = indexOwner;
                    } else if (!isTypeSelected && !type.disabled) {
                        type.disabled = false;
                        type.indexOwner = null;
                    } else if (!isTypeSelected && type.disabled) {
                        type.disabled = false;
                        type.indexOwner = null;
                    }
                })
            }

            vm.getDocumentTypes = () => {
                HelperService.startLoading('.document-container', true);

                if (vm.type == 1) {
                    return PersonService
                        .getDocumentTypes()
                        .then(success => {
                            vm.documentTypes = success;
                            HelperService.stopLoading('.document-container')
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.document-container')
                        })
                } else {
                    return UnitService
                        .getDocumentTypes()
                        .then(success => {
                            vm.documentTypes = success;
                            HelperService.stopLoading('.document-container')
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.document-container')
                        })
                }
            }

            /**
             * Consulta o CNPJ na Receita Federal no momento em que o campo e' preenchido, e avisa na tela.
             *
             * Por que aqui e nao no formulario: o campo de documento e' desta diretiva, entao a conferencia e o aviso
             * tambem. O que fazer com o DADO e' do formulario -- quem passa `on-company-found` recebe a resposta e
             * decide (a tela de loja preenche a razao social; a de pessoa nao passa nada e so' ve o aviso).
             *
             * CNPJ PROVISORIO (14 digitos iguais, ex. 11111111111111) faz BYPASS: loja em abertura entra com marcador
             * e troca pelo definitivo depois, entao acusar erro ali impediria o cadastro de existir. A API classifica
             * como 'Placeholder' e nao consulta ninguem; aqui so' nao se marca como erro.
             *
             * Terceiro fora do ar nao vira erro de cadastro: 'Unavailable' aparece como aviso neutro, nao como recusa.
             */
            vm.checkCompanyRegistry = documentPosition => {
                const documento = vm.documents && vm.documents[documentPosition];
                const codigo = documento && documento.Document ? documento.Document.Code : null;

                delete vm.companyRegistry[documentPosition];

                // So' CNPJ (tipo 5), e so' com os 14 digitos: avisar a cada tecla seria ruido.
                if (!documento || documento.DocumentTypeId != 5)
                    return $q.resolve(null);

                const digitos = (codigo || '').replace(/\D/g, '');

                if (digitos.length !== 14) {
                    delete vm.ultimoCnpjConsultado[documentPosition];
                    return $q.resolve(null);
                }

                // Dispara no 14o digito (ng-change) E ao sair do campo (ng-blur), mas consulta UMA vez por CNPJ: sem
                // isto o mesmo numero seria consultado duas vezes a cada preenchimento.
                if (vm.ultimoCnpjConsultado[documentPosition] === digitos) {
                    vm.companyRegistry[documentPosition] = vm.ultimaResposta[documentPosition];
                    return $q.resolve(null);
                }

                vm.ultimoCnpjConsultado[documentPosition] = digitos;
                vm.companyRegistry[documentPosition] = { consultando: true };

                return CompanyRegistryService
                    .getByCnpj(digitos)
                    .then(resposta => {
                        if (!resposta) {
                            delete vm.companyRegistry[documentPosition];
                            return null;
                        }

                        vm.companyRegistry[documentPosition] = {
                            outcome: resposta.Outcome,
                            mensagem: resposta.Message,
                            // 'Found' ativo nao tem mensagem; 'Placeholder' tem, mas e' informativa, nao erro.
                            erro: resposta.Outcome === 'Invalid' || resposta.Outcome === 'NotFound'
                                || (resposta.Outcome === 'Found' && resposta.IsActive === false),
                            razaoSocial: resposta.CorporateName
                        };

                        vm.ultimaResposta[documentPosition] = vm.companyRegistry[documentPosition];

                        if (resposta.Outcome === 'Found' && angular.isFunction(vm.onCompanyFound))
                            vm.onCompanyFound({ company: resposta });

                        return resposta;
                    }, () => {
                        // Falha de rede do proprio front: nao se transforma em erro de CNPJ.
                        vm.companyRegistry[documentPosition] = {
                            outcome: 'Unavailable',
                            mensagem: 'Nao foi possivel consultar a Receita Federal agora.',
                            erro: false
                        };
                        // Indisponibilidade nao e' guardada: sair e voltar ao campo tenta de novo.
                        delete vm.ultimoCnpjConsultado[documentPosition];

                        return null;
                    });
            }

            init();

            function init() {
                vm.documentTypes = [];
                vm.companyRegistry = {};
                vm.ultimoCnpjConsultado = {};
                vm.ultimaResposta = {};
                vm.getValidationMessage = $rootScope.ValidationMessage;
            }
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.getDocumentTypes()
                .then(() => {
                    ctrl.amountOfDocuments = 1;

                    if (ctrl.documents && ctrl.documents.length) {
                        ctrl.amountOfDocuments = ctrl.documents.length;

                        for (let index = 0; index < ctrl.documents.length; index++) {
                            const document = ctrl.documents[index];
                            let documentType = ctrl.documentTypes.find(type => (type.Id == document.DocumentTypeId));

                            if (documentType) {
                                documentType.disabled = true;
                                documentType.indexOwner = index;
                            }
                        }

                        if (ctrl.amountOfDocuments == 0)
                            ctrl.amountOfDocuments = 1;
                    } else
                        ctrl.documents = [];
                })
        }

        return {
            bindToController: true,
            controller: DocumentFieldController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/document-field/document-field.html`,
            scope: {
                documents: '=',
                type: '=',
                canEdit: '=',
                // Opcional: quem quiser aproveitar o dado da Receita passa um callback. Sem ele a diretiva so' avisa.
                onCompanyFound: '&?'
            }
        }
    }
}());